import React, { memo } from 'react'
import { FormControl } from 'react-bootstrap'

export const SearcherByNombre = memo(({ value, handleInputChange }) => {

    return (
        <>
            <FormControl
                required
                type="text"
                name="buscar"
                placeholder="Escriba un nombre"
                onChange={handleInputChange}
                value={value}
            />
        </>
    )
})
